import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-container-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_hint = _resolveComponent("hint")!
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_input, {
      id: _ctx.id,
      label: _ctx.computedLabel,
      placeholder: _ctx.localize('phoneNumberPlaceholder'),
      name: "tel",
      autocomplete: "tel",
      value: _ctx.modelValue,
      onFocus: _ctx.onFocus,
      onBlur: _ctx.onBlur,
      onInput: _ctx.onInput,
      onKeydown: _ctx.onKeyDown
    }, null, 8, ["id", "label", "placeholder", "value", "onFocus", "onBlur", "onInput", "onKeydown"]),
    _createVNode(_component_hint, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.localize('mobileNumberHint')), 1)
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_error, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showError]
    ])
  ]))
}